<template>
  <div class="WechatUsers">
    <div class="topselect">
      <header>
        <!-- <el-input v-model="wechatUsersQuery.channel_code" placeholder="渠道号名称" style="width: 200px; margin-right: 10px;" /> -->
        <el-select
          v-model="wechatUsersQuery.platform_id"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="clean"
          @change="alew"
        >
          <el-option
            v-for="(item, index) in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-input
          v-model="wechatUsersQuery.channel_code"
          placeholder="渠道号"
          style="width: 200px; margin-right: 10px"
        />
        <el-input
          v-model="wechatUsersQuery.channel_name"
          placeholder="渠道名称"
          style="width: 200px; margin-right: 10px"
        />
        <el-input
          v-model="wechatUsersQuery.optimizer"
          placeholder="优化师"
          style="width: 200px; margin-right: 10px"
        />
        <el-select
          v-model="wechatUsersQuery.novel_id"
          placeholder="请选择书籍"
          filterable
          :clearable="true"
          @focus="getbooks"
        >
          <el-option
            v-for="(item, index) in bookList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <!-- <el-date-picker
          v-model="wechatUsersQuery.date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        /> -->
        <el-date-picker
          v-model="timesr"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions1"
          :default-value="timeDefaultShow"
          @click.once="changeInitCalendarPage"
        />
        <el-button
          type="primary"
          style="margin-right: 5px; margin-left:10px"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          @click="reset"
        >重置</el-button>
        <el-button
          type="primary"
          icon="el-icon-download"
          style="margin-left:10px"
          @click="exportChannelReport()"
        >导出</el-button>

        <!-- <el-button type="primary" @click="showDaysOrNot = !showDaysOrNot">
          {{ showDaysOrNot ? '收起天数' : '展开天数' }}
        </el-button> -->
      </header>
    </div>
    <main>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="channel_date"
          label="日期"
          min-width="150"
          align="center"
        />
        <el-table-column
          prop="platform"
          label="平台"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="channels"
          label="渠道号"
          min-width="200"
          align="center"
        >
          <template scope="scope">
            <span
              style="min-width: 100px;overflow:hidden;white-space: nowrap; text-overflow: ellipsis;"
              :style="{ whiteSpace: scope.row.channels.join('、').includes('、') && openChannels.includes(scope.row.id) ? 'break-spaces' : 'nowrap'}"
              :title="scope.row.channels.join('、')"
            >{{
              scope.row.channels.includes('、') ? openChannels.includes(scope.row.id) ? scope.row.channels.join('、').split('、').join('\n') : scope.row.channels.join('、') : scope.row.channels.join('、')
            }}</span>
            <p
              v-if="scope.row.channels.join('、').includes('、')"
              style="cursor: pointer; color: #0088ff;"
              @click="openChannels.includes(scope.row.id) ?
                openChannels = openChannels.filter(id => id !== scope.row.id) :
                openChannels.push(scope.row.id)"
            >{{ openChannels.includes(scope.row.id) ? '收起' : '展开' }}</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="channel_names"
          label="渠道名称"
          min-width="200"
          align="center"
        >
          <template scope="scope">
            <span
              style="min-width: 100px;overflow:hidden;white-space: nowrap; text-overflow: ellipsis;"
              :style="{ whiteSpace: scope.row.channel_names.join('、').includes('、') && openChannelNames.includes(scope.row.id) ? 'break-spaces' : 'nowrap'}"
              :title="scope.row.channel_names.join('、')"
            >{{
              scope.row.channel_names.includes('、') ? openChannelNames.includes(scope.row.id) ? scope.row.channel_names.join('、').split('、').join('\n') : scope.row.channel_names.join('、') : scope.row.channel_names.join('、')
            }}</span>
            <p
              v-if="scope.row.channel_names.join('、').includes('、')"
              style="cursor: pointer; color: #0088ff;"
              @click="openChannelNames.includes(scope.row.id) ?
                openChannelNames = openChannelNames.filter(id => id !== scope.row.id) :
                openChannelNames.push(scope.row.id)"
            >{{ openChannelNames.includes(scope.row.id) ? '收起' : '展开' }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="novels"
          label="书籍名称"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="optimizers"
          label="优化师"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="new_num"
          label="新用户"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="new_recharge"
          label="新用户充值"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="new_roi"
          label="新用户roi"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="new_unit"
          label="新增单价"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="total_recharge"
          label="累积充值"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="today_cost"
          label="今日消耗"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="total_cost"
          label="总消耗(不含当日)"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="today_roi"
          label="当日回收"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="pay_growth_rate"
          label="付费增长率"
          min-width="100"
          align="center"
        />
        <!--  <template v-if="showDaysOrNot">
          <el-table-column
            v-for="(item, index) in maxLength"
            :key="item"
            prop=""
            width="170"
            :label="`第${index + 1}天充值`"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row" class="recharge">
                <span>{{ scope.row.t_plus[index].zc
                }}{{ scope.row.t_plus[index].zc !== "-" && "元" }}</span>
                <br>
                <span>回：{{ scope.row.t_plus[index].zcb
                }}{{ scope.row.t_plus[index].zcb !== "-" && "%" }}</span>
                <br>
                <span>增：{{ scope.row.t_plus[index].zzl
                }}{{ scope.row.t_plus[index].zzl !== "-" && "%" }}</span>
              </div>
            </template>
          </el-table-column>
        </template> -->
      </el-table>
    </main>
    <add-account-drawer ref="addAccountDrawer" />
    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import addAccountDrawer from '@/views/report/channelListcompent/components/addAccountDrawer.vue'
// import addchanForm from '@/views/report/channelListcompent/components/addchanForm.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
/* getchannelList ,*/
  getchannelplatform
} from '@/api/report/wechatUsers.js'
import { getList, exportChannelGeneralReport } from '@/api/report/generalChannelReport.js'
import { getselectlist, importR, /* getSelectList, */ novelListScreen } from '@/api/providerAccountManagement/WeChatAccountFans'
export default {
  name: 'GeneralChannelReport',
  components: {
    PaginationRight,
    addAccountDrawer
    /*  addchanForm */
  },
  data() {
    return {
      tableData: {},
      platformSelectList: [], // 获取平台数据列表
      openChannels: [],
      openChannelNames: [],
      showDaysOrNot: false,
      wechatUsersQuery: {
        platform_id: undefined,
        channel_code: undefined,
        channel_name: undefined,
        optimizer: undefined,
        novel_id: undefined,
        date: this.getNowTime(),
        page: 1,
        page_size: 10
      },
      bookList: [],
      timesr: '',
      timeDefaultShow: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > (Date.now() - (24 * 60 * 60 * 1000))
        }
      },
      pickerOptions1: {
        disabledDate(v) {
          return (
            v.getTime() >
            new Date().getTime() - (86400000 - 24 * 60 * 60 * 1000) - (24 * 60 * 60 * 1000)
          )
        }
      },
      loading: false, // 加载效果
      dialogVisible: false,
      maxLength: 0
    }
  },
  created() {
    this.getListData()
    this.getpingtai()

    window.aa = this
  },
  methods: {
    clean() {
      this.wechatUsersQuery.platform_id = undefined
      this.wechatUsersQuery.channel_code = undefined
      this.wechatUsersQuery.novel_id = undefined
      this.bookList = []
      this.getListData()
    },
    changeInitCalendarPage() {
      const dom = document.querySelector('button.button.el-picker-panel__icon-btn.el-icon-arrow-left')
      if (dom) {
        dom.click()
      }
    },
    // 获取书籍
    async getbooks() {
      let text = null
      if (!this.wechatUsersQuery.platform_id) {
        text = '请选择平台'
      }
      if (text) {
        this.$message({
          message: text,
          type: 'warning'
        })
      } else {
        const data = await novelListScreen({ platform_id: this.wechatUsersQuery.platform_id })
        this.bookList = data.data.list
      }
    },

    // 获取平台数据
    getpingtai() {
      this.loading = true
      getchannelplatform().then((res) => {
        this.platformSelectList = res.data.list
        this.loading = false
      })
    },
    // 获取列表数据
    getListData() {
      this.loading = true

      getList({
        ...this.wechatUsersQuery,
        start_date: this.timesr ? this.timesr[0] : null,
        end_date: this.timesr ? this.timesr[1] : null
      }).then((res) => {
        res.data.list.forEach((item) => {
          item.id = Math.random()
          item.t_plus && item.t_plus.length > this.maxLength && (this.maxLength = item.t_plus.length)
        })
        this.tableData = res.data

        // this.data.startTime = res.data.list.created_at
        // this.data.endTime = res.data.list.end_time
        this.loading = false
      })
    },
    // 点击新增回调
    handle() {
      this.dialogVisible = false
      this.getListData()
    },
    // 分页
    fetchPageSize(e) {
      this.wechatUsersQuery.page_size = e
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.wechatUsersQuery.page = e
      this.getListData()
    },
    // 搜索数据
    search() {
      this.wechatUsersQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    reset() {
      this.wechatUsersQuery = {
        platform_id: undefined,
        channel_code: undefined,
        channel_name: undefined,
        optimizer: undefined,
        novel_id: undefined,
        date: this.getNowTime(),
        page: 1,
        page_size: this.wechatUsersQuery.page_size
      }
      this.timesr = ''
      this.getListData()
    },
    async exportChannelReport() {
      const data = await exportChannelGeneralReport({
        channel_code: this.wechatUsersQuery.channel_code,
        platform_id: this.wechatUsersQuery.platform_id,
        optimizer: this.wechatUsersQuery.optimizer,
        novel_id: this.wechatUsersQuery.novel_id,
        start_date: this.timesr ? this.timesr[0] : this.getYesterday(),
        end_date: this.timesr ? this.timesr[1] : this.getYesterday()
      })
      this.$message({
        message: `导出成功，任务ID为：${data.data.task_id}`,
        type: 'success'
      })
      this.dialogVisible = false
      this.reset()
    },
    judge(wechatUsersQuery, timesr) {
      let text = null
      /* if (!wechatUsersQuery.platform_id) {
        text = '请选择平台'
      } else if (!wechatUsersQuery.channel_code) {
        text = '请输入渠道号'
      } else if (!wechatUsersQuery.optimizer) {
        text = '请输入优化师'
      } else  */if (timesr === null || !timesr.length) {
        text = '请选择日期'
      }

      if (text) {
        this.$message({
          message: text,
          type: 'warning'
        })
        return false
      }
      return true
    },
    querySearchAsync(queryString, callback) {
      var list = [{}]
      getselectlist({
        keyword: this.wechatUsersQuery.channel_code,
        platform_id: this.wechatUsersQuery.platform_id
      }).then((response) => {
        for (const i of response.data) {
          i.value = i.channel_code // 想要展示的数据 // 将想要展示的数据作为value
        }
        list = response.data
        callback(list)
      })
    },
    handleSelect(item) {
      console.log(item)
      // do something
    },
    alew() {
      this.wechatUsersQuery.channel_code = null
    },
    async importReport() {
      const file = new FormData()
      file.append('file', this.$refs.inputFile.files[0])
      await importR(file)
      this.$message({
        message: '导入报表成功',
        type: 'success'
      })
    },
    getNowTime() {
      var now = new Date()
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      // var hour = ' 00:00:00' // 默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      var defaultDate = `${year}-${month}-${date}`
      console.log(defaultDate)
      return undefined
    },
    getYesterday() {
      const date = new Date()
      const month = date.getMonth() + 1
      const day = date.getDate() - 1
      return `${date.getFullYear()}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    }
  }
}
</script>

<style scoped lang="less">
.add {
  margin-left: 20px;
}
.topselect {
  display: flex;
}
.WechatUsers {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
